import React, { useEffect, useState } from 'react';
import '../styles/Footer.css';
import { FaPhoneAlt, FaEnvelope, FaArrowUp } from 'react-icons/fa';

const Footer = () => {
  const [showButton, setShowButton] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

      setScrollProgress(progress);
      setShowButton(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // SVG circle math
  const size = 52;
  const strokeWidth = 3;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (scrollProgress / 100) * circumference;

  return (
    <footer className="footer-section">
      <div className="footer-overlay">
        <div className="footer-column">
          <h4>COMPANY</h4>
          <ul>
            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/clientpg">Our Clients</a></li>
            <li><a href="/careerspg">Careers</a></li>
            <li><a href="/contactpg">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>QUICK LINKS</h4>
          <ul>
            <li>
              <a href="mailto:services@apexcel.ae" target="_blank" rel="noopener noreferrer">
                Request The Quote Now
              </a>
            </li>
            <li><a href="/contactpg">Rent It Now</a></li>
            <li><a href="/projects/ongoing">Ongoing Projects</a></li>
            <li><a href="/projects/completed">Completed Projects</a></li>
            <li><a href="/projects/appreciationpg">Appreciation Certification</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>SERVICES</h4>
          <ul>
            <li><a href="/services/designpg">Engineering Design</a></li>
            <li><a href="/services/elecinstallatingpg">Electrical Installation</a></li>
            <li><a href="/services/testingcommissioningpg">Testing & Commissioning</a></li>
            <li><a href="/services/Renewablepg">Solar Power Grid</a></li>
            <li><a href="/services/operationmaintenancepg">Maintenance Services</a></li>
            <li><a href="/services/equipmentrentalpg">Equipment Rental</a></li>
            <li><a href="/services/oilfiltrationpg">Transformer Oil Filtration</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>CONTACT</h4>
          <ul>
            <li><strong className="cl1">Dubai [UAE]</strong></li>
            <li>
              <FaPhoneAlt className="footer-icon" />
              <a href="tel:+97142634821"> +971 4 263 4821</a>
            </li>
            <li>
              <FaEnvelope className="footer-icon" />
              <a href="mailto:services@acume.ae">services@acume.ae</a>
            </li>
          </ul>
          <ul>
            <li><strong className="cl1">Abu Dhabi [UAE]</strong></li>
            <li>
              <FaPhoneAlt className="footer-icon" />
              <a href="tel:+97125652100"> +971 2 565 2100</a>
            </li>
            <li>
              <FaEnvelope className="footer-icon" />
              <a href="mailto:services@acume.ae">services@acume.ae</a>
            </li>
          </ul>
          <ul>
            <li><strong className="cl1">Kingdom Of Saudi Arabia</strong></li>
            <li>
              <FaPhoneAlt className="footer-icon" />
              <a href="tel:+966538269720"> +966538269720</a>
            </li>
            <li>
              <FaEnvelope className="footer-icon" />
              <a href="mailto:services.ksa@acumegcc.com">services.ksa@acumegcc.com</a>
            </li>
          </ul>
        </div>
      </div>

      {/* ── Scroll Progress Button ── */}
      <div
        className={`scroll-to-top-wrapper ${showButton ? 'visible' : ''}`}
        onClick={scrollToTop}
        title="Back to top"
      >
        {/* Outer glow ring */}
        <div className="scroll-glow-ring" />

        {/* SVG progress circle */}
        <svg
          className="scroll-progress-svg"
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
        >
          {/* Background track */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="rgba(255,120,3,0.15)"
            strokeWidth={strokeWidth}
          />
          {/* Progress arc */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="#ff7803"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            style={{ transition: 'stroke-dashoffset 0.15s ease' }}
          />
        </svg>

        {/* Inner button face */}
        <div className="scroll-inner">
          <FaArrowUp className="scroll-arrow-icon" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;